/**
* Alien Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Alien Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'alien-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.alien-content' ).each( function( key, val ) {
        const height = $( this ).outerHeight();
        window.scrollRefreshPriority--;

        const alienScroll = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            end: '=+' + ( height * 2 ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 1,
          },
        } );

        const locations = [];
        $( this ).find( '.aliens-attack .alien' ).each( function( alienKey, alien ) {
          const containerWidth = $( alien ).closest( '.relative' ).outerWidth();
          const containerHeight = $( alien ).closest( '.relative' ).outerHeight();
          const y = ( Math.floor( Math.random() * 175 ) + 1 );
          const scale = ( Math.floor( Math.random() * ( 2.5 - 1.5 + 1 ) + 1.5 ) );

          let top = 0;
          let left = 0;
          let bottom = 0;
          let right = 0;

          let overlapped = true;
          let i = 0;

          while ( overlapped ) {
            top = 0;
            left = ( Math.floor( Math.random() * ( containerWidth - 0 + 1 ) + 0 ) );
            bottom = top + $( alien ).outerHeight();
            right = left + $( alien ).outerWidth();

            overlapped = false;
            locations.forEach( ( val, index ) => {
              if (
                ( bottom < val.top || top > val.bottom ) ||
                ( left > val.right || right < val.left )
              ) {
                // overlapped = false;
              } else {
                overlapped = true;
              }
            } );
            i++;
            if ( i > 1000 || locations.length == 0 ) {
              overlapped = false;
            }
          }

          $( alien ).css( {
            'top': top,
            'left': left,
            'transform': 'translateY(' + y + 'px) scale(' + scale + ')',
          } );

          locations.push( {
            'top': top,
            'left': left,
            'bottom': bottom,
            'right': right,
          } );

          alienScroll.to( alien, {y: '-10px', ease: 'linear'}, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'alien-content', COMPONENT );
} )( app );
